'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var OptionProvider = require('../../components/OptionProvider.js');
var styles_module = require('./styles.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Swatch() {
  const {
    option: {
      label
    },
    isSelected,
    isDisabled
  } = OptionProvider.useOption();
  if (!label || typeof label !== 'string') {
    throw new Error('Swatch only accepts string label that matches background css.');
  }
  const swatchClassNames = clsx.clsx(styles_module["default"].swatch, isSelected && styles_module["default"].swatchSelected, isDisabled && styles_module["default"].swatchDisabled);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: swatchClassNames,
    style: {
      background: label
    }
  }), isDisabled && /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles_module["default"].diagonalLine
  }));
}

exports.Swatch = Swatch;
